module.exports = __webpack_public_path__ + "img/it-stinks-and-they-dont-like-it.f5f18462.png";